export const storageHelper = {
  setItem: (key: string, value: string) => {
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  },
  getItem: (key: string): string | null => {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  },
  removeItem: (key: string) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  },
};
